import React from "react";

import {Header, Icon, Table, SemanticICONS} from "semantic-ui-react";
import dayjs = require("dayjs");

import {FormatUtils} from "../../../../../../../utils/format-utils";
import {UnitsUtils} from "../../../../../../../utils/units-utils";
import {FieldInfoFormatConfiguration} from "../../../../../../../core/config/field-info-configuration";
import {DataValueType} from "../../../../../../../kiwis/data-value-type";
import {ColorUtils} from "../../../../../../../utils/color-utils";

interface MeasurementInfoTableRowProps {
    stationId: number;
    label: string;
    value: number;
    relativeValue?: number | null | undefined;
    date: Date;
    format: FieldInfoFormatConfiguration;
    dateFormat: string;
    timeFormat: string;
    colorVariable: __esri.ColorVariable;
    useColorVariableLabel: boolean;
    unit: string;
    icon: SemanticICONS;
}

export class MeasurementInfoTableRow extends React.Component<MeasurementInfoTableRowProps, any> {
    constructor(props: any) {
        super(props);
    }

    styleMeasurementValue(value: number, type: DataValueType) {
        const style = this.props.colorVariable ?
            FormatUtils.visualFormat(value, this.props.colorVariable, this.props.useColorVariableLabel) : null;
        const val = this.extractValue(value, style);
        const formattedValue = `${val} ${UnitsUtils.unitLabel(this.props.unit, type)}`;

        return { style, formattedValue };
    }

    extractValue(value: number, style: any) {
        if (this.props.useColorVariableLabel && style.colorLabel) {
            return style.colorLabel;
        }
        if (this.props.format) {
            return FormatUtils.formatValue(value, this.props.format);
        }
        return value;
    }

    render() {
        const {date, dateFormat, icon, label, relativeValue, timeFormat, value} = this.props;
        const styledValue = this.styleMeasurementValue(value, DataValueType.Absolute);
        let labelColor;
        if (styledValue.style?.backgroundColor) {
            labelColor = ColorUtils.invertColor(`${styledValue.style.backgroundColor}`, true);
        }
        let styledRelativeValue = null;
        if (relativeValue) {
            styledRelativeValue = this.styleMeasurementValue(relativeValue, DataValueType.Relative);
        }
        if (styledRelativeValue?.style?.backgroundColor) {
            labelColor = ColorUtils.invertColor(`${styledRelativeValue.style.backgroundColor}`, true);
        }
        return (
            <Table.Row className={"geo-measurements-pane-table-row"}>
                <Table.Cell>
                    <Header as="h4">
                        {icon && <Icon name={icon} size="tiny"/>}
                        <Header.Content>{label}</Header.Content>
                    </Header>
                </Table.Cell>
                <Table.Cell
                    style={styledValue.style}
                    className={styledValue.style ? "measurement-value-white" : undefined }>
                    <span style={{color: labelColor }} className="measurement-value-label">
                        {styledValue.formattedValue}
                        {styledRelativeValue && <br/>}
                        {styledRelativeValue && `${styledRelativeValue.formattedValue}` }
                    </span>
                </Table.Cell>
                <Table.Cell>
                    {dayjs(date).format(dateFormat)}<br/>
                    {timeFormat ? dayjs(date).format(timeFormat) : null}
                </Table.Cell>
            </Table.Row>
        );
    }

}
